import type { Point } from '@os/engine';
import * as Y from 'yjs';
import type { NewObject } from './commands';
import { newId } from './ids';
import { TABLE_MAX_COLS, TABLE_MAX_ROWS, TABLE_ROW_H } from './schema';

export const TABLE_COL_W = 160;
export const TABLE_MIN_COL_W = 40;
export const TABLE_MAX_COL_W = 800;

/** An empty table of `rows` × `cols` (default columns), centred on `at`. */
export function newTable(rows: number, cols: number, at: Point): NewObject {
  const r = Math.min(Math.max(1, Math.floor(rows)), TABLE_MAX_ROWS);
  const c = Math.min(Math.max(1, Math.floor(cols)), TABLE_MAX_COLS);
  const colList = Array.from({ length: c }, () => ({ id: newId(), w: TABLE_COL_W }));
  const w = c * TABLE_COL_W;
  const h = r * TABLE_ROW_H;
  return {
    type: 'table', parentId: null, x: at.x - w / 2, y: at.y - h / 2, w, h, rotation: 0, locked: false, style: {},
    cols: colList,
    rows: Array.from({ length: r }, () => ({ id: newId(), cells: Object.fromEntries(colList.map((col) => [col.id, ''])) })),
  };
}

/** Rewrites `t` to `next` by its common prefix and suffix, so concurrent edits elsewhere in the cell merge. */
export function applyTextDiff(t: Y.Text, next: string): void {
  const cur = t.toString();
  if (cur === next) return;
  let start = 0;
  while (start < cur.length && start < next.length && cur[start] === next[start]) start++;
  let end = 0;
  while (end < cur.length - start && end < next.length - start && cur[cur.length - 1 - end] === next[next.length - 1 - end]) end++;
  if (cur.length - start - end > 0) t.delete(start, cur.length - start - end);
  if (next.length - start - end > 0) t.insert(start, next.slice(start, next.length - end));
}
